import {QueryClientProvider} from '@tanstack/react-query';
import {ReactElement} from 'react';
import {queryClient} from '../infra/QueryClient';

const QueryProvider = ({children}: {children: ReactElement}) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};
QueryProvider.displayName = 'QueryProvider';

export default QueryProvider;
